import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface SiteList {
  siteName: string
  description: string
}
export interface SiteListState {
  isLoading: boolean
  loadingError: string | null
  siteList: SiteList[] | null
  siteCount: number
  httpStatus: number | null
}

const initialState: SiteListState = {
  isLoading: true,
  loadingError: null,
  siteList: null,
  siteCount: 0,
  httpStatus: null
}

const siteListSlice = createSlice({
  name: 'siteManagementSiteList',
  initialState,
  reducers: {
    siteListLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        siteList: null,
        siteCount: 0,
        httpStatus: 0
      }
    },
    siteListUpdateAction: (state, action: PayloadAction<{ data: SiteList[], count: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        siteList: action.payload.data,
        siteCount: action.payload.count,
        httpStatus: action.payload.httpStatus
      }
    },
    siteListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        siteList: null,
        siteCount: 0,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  siteListLoadingAction,
  siteListUpdateAction,
  siteListErrorAction
} = siteListSlice.actions

export default siteListSlice.reducer
